<template>
  <div class="container-black-bg">

    <span v-if="count === 4"> Ready</span>
    <span v-if="count !== 4">{{count}}</span>
  </div>
</template>

<script>
export default {
  name: "Counter",
  data() {
    return {
      count: 4,
      eventEmit: false
    };
  },
  created() {
    setInterval(() => {
      if (this.count !== 0) {
        this.count--;
      } else {
        clearInterval();
        if (!this.eventEmit) {
          this.$emit("onRecord");
          this.eventEmit = true;
        }
      }
    }, 1000);
  }
};
</script>

<style scoped>
span {
  font-size: 6rem;
  color: white;
  margin-bottom: 30px;
}

div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height:100%;
}
</style>
